import { FileResponse } from "./file-upload-interfaces";

export interface Contract {
    supplier: string | null;
    contract_start: string | null;
    contract_end: string | null;
    termination_type: string | null;
    file: FileResponse | null;
    company_id: string | null;
    location_id: string | null;
    status: ContractStatus | null;
}

export enum ContractStatus {
    CREATED = "CREATED",
    IN_VALIDATION = "IN_VALIDATION",
    VALID = "VALID",
    DATA_MISSING = "DATA_MISSING",
    IN_PROCESSING = "IN_PROCESSING",
    DONE = "DONE",
    ERROR = "ERROR"
}